<template>
  <div class="home-page">
    <HeroSection />
    <SpeakersSection />
    <AgendaHighlights />
    <TicketPricing />
    <OneTicket3Shows />

    <About />
    <!-- <PastExhibitors /> -->
    <Newsletter />
  </div>
</template>

<script>
import HeroSection from "../components/HeroSection.vue";
import SpeakersSection from "../components/SpeakersSection.vue";
// import AttendedBy from '../components/AttendedBy.vue'
import TicketPricing from "../components/TicketPricing.vue";
import OneTicket3Shows from "../components/OneTicket3Shows.vue";
import AgendaHighlights from "../components/AgendaHighlights.vue";
import About from "../components/About.vue";
// import PastExhibitors from '../components/PastExhibitors.vue'
import Newsletter from "../components/Newsletter.vue";

export default {
  name: "HomePage",
  components: {
    HeroSection,
    SpeakersSection,
    // AttendedBy,
    TicketPricing,
    OneTicket3Shows,
    AgendaHighlights,
    About,
    // PastExhibitors,
    Newsletter,
  },
};
</script>

<style scoped>
.home-page {
  width: 100%;
}
</style>
